import { actionTypes } from "../actions/default.action"

const initialState = {
  products: {
    data: [],
  },
  product: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        products: {
          ...state.products,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        products: {
          ...state.products,
          data: state.products.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        product: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
